export class OrderEntity {
  /**
   * @typedef {{
   * data: jsonForm,
   * states: {
   * lastStep: number,
   * verifiedStepsCount: number,
   * step: number,
   * opened: number}
   * }} LocalData
   */

  /**
   * @typedef {{
    "name": string,
    "phone": string,
    "email": string,

    "vin": string|null,
    "comment_for_auto": string|null,

    "delivery_method": string,

    "index": string|null,
    "region": string|null,
    "city": string,
    "street": string,
    "building": string,
    "flatRoom": string|null,
    "flat": string|null,
    "intercom_code": string|null,
    "date": string|null,
    "apartment": string|null,

    }} jsonForm - Содержимое формы
   */

  /** @type HTMLElement */
  order;

  /**
   * Disable step validation
   * @type boolean */
  debug;

  /**
   * @typedef {{
   * lastStep: number,
   * verifiedStepsCount: number,
   * step: number,
   * opened: number
   * }} OrderStates
   * @param {OrderStates}
   */
  TAB_STATES = {
    step: 1,
    lastStep: 1,
    verifiedStepsCount: 1,
    opened: 1,
  };

  /** @type {FormData} */
  data = new FormData();

  /**
   * @type {[Tab]}
   */
  TABS = [];

  /**
   * @typedef {{ init: function, setParent: function(*)}} plugin
   */

  /**
   * @type {plugin}
   */
  plugins = {};
}
